export async function handleRetroBo(token: string) {
    let redirectToResults = !window?.tfServices?.bookingService?.getBookingTokenQuote

    try {
        if (window?.tfServices?.bookingService?.getBookingTokenQuote) {
            const quote = await window.tfServices.bookingService.getBookingTokenQuote(token, true)
            console.log('quote', quote)
            if (quote?.state?.liheId) {
                window.location.href = `${window.location.origin}/lihe/${quote.booking.liheId}#&BeginDate=${quote.state.startDate}&EndDate=${quote.state.endDate}`
            } else {
                redirectToResults = true
            }
        }
    } catch (error) {
        redirectToResults = true
    }


    if (redirectToResults) {
        window.location.href = `${window.location.origin}/se-results`
    }
}